export default __webpack_public_path__ + "static/media/report-analytics-analytics.5410e645.png";